<template>
  <b-tabs
    v-if="!showSimplifiedInterface"
    :end="mobile"
    no-nav-style
    :nav-class="`item-tab-nav ${commentsEnabled ? '' : 'no-comments'}`"
    content-class="mt-3">
    <b-tab v-if="mobile" title="Overview">
      <item-actions :is-owner="isOwner"></item-actions>
    </b-tab>
    <b-tab :title="discussionTabTitle" v-if="commentsEnabled">
      <template>
        <div :class="{ 'absolute-container': !mobile, 'pb-2': mobile }">
          <emoji-reactions
            v-if="reactionsEnabled"
            :id="item.id"
            :reactions="itemReactions"
            :type="item.type"
          />
        </div>
        <comments />
      </template>
    </b-tab>
    <b-tab v-if="transcriptionTabEnabled" @click="trackTranscriptionViewed">
      <template #title>
        <span>Transcription</span>
        <span class="beta-badge">BETA</span>
      </template>
      <transcription v-if="(transcriptionFeatureEnabled || isTranscriptionStatusDone) && !isTranscriptionLoading "/>
      <transcription-skeleton v-if="isTranscriptionLoading || !transcriptionFeatureEnabled"/>
      <transcription-skeleton-overlay v-if="!transcriptionFeatureEnabled && !isTranscriptionLoading && isFeaturesLoaded"/>
    </b-tab>
  </b-tabs>
</template>

<script>
import Comments from '@cmp/viewer/comments.vue';
import ItemActions from '@cmp/viewer/item_actions.vue';
import Transcription from '@cmp/viewer/transcription.vue';
import featureKey from '../../feature_key.macro';
import { mapState } from 'vuex';
import EmojiReactions from "@cmp/viewer/emoji_reactions.vue"
import TranscriptionSkeleton from '@cmp/viewer/transcription_skeleton.vue';
import TranscriptionSkeletonOverlay from '@cmp/viewer/transcription_skeleton_overlay.vue';
import track from '@/src/tracking';

export default {
  components: { Comments, EmojiReactions, ItemActions, Transcription, TranscriptionSkeleton, TranscriptionSkeletonOverlay },
  props: {
    zoomed: { type: Boolean, default: false }
  },
  created: function(){
    addEventListener('resize', () => this.mobile = innerWidth < 768)

    if (!this.transcriptionId) {
      this.$store.commit('setTranscriptionLoading', false)
    } else {
      this.$store.dispatch('getTranscription', this.transcriptionId);
    }
  },
  data: function(){
    return {
      mobile: window.innerWidth < 768
    }
  },
  computed: {
    ...mapState({
      item: state => state.item,
      comments: state => state.comments,
      transcription: state => state.transcription,
      isFeaturesLoaded: state => state.featuresLoaded,
      itemOrganization: state => state.itemOrganization,
      transcriptionFeatureEnabled: state => state.features?.[featureKey("viewer-transcription")],

    }),
    isTranscriptionLoading() {
      return this.transcription.isLoading;
    },
    isOwner: function(){ return this.$root.isOwner },
    commentsEnabled: function(){
      return !this.itemOrganization.attributes.preferences.comments_disabled
            && !this.item.attributes.comments_disabled
            && !this.item.attributes.view_limit_reached
    },
    itemReactions() {
      return this.item?.relationships?.reactions?.data;
    },
    discussionTabTitle: function () {
      if (this.$root.userLoggedIn) return 'Discussion';
      else if (!this.item.attributes.allow_anonymous_comments && this.comments.length === 0) {
        return '';
      }
      return 'Discussion';
    },
    reactionsEnabled() {
      return !this.itemOrganization.attributes.preferences.reactions_disabled
        && !this.item.attributes.reactions_disabled
    },
    transcriptionTabEnabled() {
      if(this.mobile){
        return false;
      }

      if (this.item.attributes.item_type != 'video') {
        return false;
      }

      return this.isOwner || this.isTranscriptionStatusDone
    },
    showSimplifiedInterface() {
      return this.$store.getters.showSimplifiedInterface;
    },
    isTranscriptionStatusDone() {
      return this.transcriptionId && this.item.relationships.transcription?.meta?.status == "done";
    },
    transcriptionId() {
      return this.item.relationships.transcription?.data?.id;
    }
  },
  methods: {
    trackTranscriptionViewed() {
      track('transcription_viewed');
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/packs/colors.scss';
  .tabs {
    position: relative;
  }

  .absolute-container {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;
  }

  ::v-deep .item-tab-nav {
    .nav-item {
      z-index: 1;
    }

    li {
      margin-bottom: 0;
      padding-right: 1rem;
    }

    li a{
      color: $silver-chalice;
      font-size: 0.875rem;
      font-weight: bold;
      padding: 0.2rem 0;
      display: flex;
      position: relative;

      &.active {
        color: $dark-gray;
        border-bottom: 2px solid $dark-gray;
      }
    }

    .beta-badge {
      position: absolute;
      background: linear-gradient(to top, #0ba360, #3cba92);
      border-radius: 10px;
      right: -45px;
      padding: 0.063rem 0.313rem 0.125rem;
      font-size: 0.625rem;
      font-weight: 900;
      color: white;
    }
  }

  @media only screen and (min-width: 768px) {
    ::v-deep .item-tab-nav {
      li {
        flex: none;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    ::v-deep .item-tab-nav {
      background: white;
      position: fixed;
      z-index: 1;
      bottom: 0;
      left: 0;
      width: 100%;

      li {
        cursor: pointer;
        flex: 1;
        text-align: center;
        color: $slate-gray;
        font-weight: 500;
        padding-right: 0;

        a {
          display: block;
          border-top: 2px solid $white-four;
          padding: 0.6rem;

          &.active {
            color: $dark-gray;
            border-top: 2px solid $dark-gray;
            border-bottom: none;
          }
        }
      }

      &.no-comments {
        display: none;
      }
    }
  }
</style>
